// 修正版 i18n.js
import { createI18n } from 'vue-i18n' // Vue 3 需要使用命名导入（重要！）
// 动态加载语言文件
const loadLocaleMessages = () => {
  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )
  const messages = {}
  locales.keys().forEach(key => {
    // 更好的路径解析方式
    const matched = key.match(/([A-Za-z0-9-_]+)\/([A-Za-z0-9-_]+)\.json$/i)
    console.log(matched)
    if (matched && matched.length > 2) {
      const locale = matched[1] // 语言代码
      const type = matched[2]   // 文件类型
      
      if (!messages[locale]) messages[locale] = {}
      messages[locale][type] = locales(key)
    }
  })
  return messages
}

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式（推荐 Vue 3 项目）
  locale: 'zh',  // 默认语言
  fallbackLocale: 'zh',
  globalInjection: true, // 启用全局变量注入
  messages: loadLocaleMessages()
})

export default i18n